<template>
	<div class="pop-mask" v-if='isModalflag' @click="closeMask">
		<div class="mask-content" @click.stop="closeFlag">
			<span >全本订购提醒</span>
			<div class="">
				<span>整本特惠</span>
				<div class="">
					<span style="color: #F63232;">{{countCurrency}} </span>
					<span> 书币</span>
				</div>
			</div>
			<div class="">
				<span>剩余书币</span>
				<div class="">
					<span>{{userCurrency}}书币</span>
					<span v-if="countCurrency>userCurrency" style="font-size: 13px;color: #F63333;">（余额不足）</span>
				</div>
			</div>
			<div class="btn" @click.stop="gotoCharge">
				<span v-if="countCurrency<=userCurrency">确 认 订 购</span>
				<span v-else>充 值</span>
			</div>
		</div>
	</div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	export default{
		props:{
			showBuyMask:{
				type: Boolean,
				default: false
			},
			countCurrency:{
				type: Number,
				default: 0
			},
			userCurrency:{
				type: Number,
				default: 0
			}
		},
		watch:{
			showBuyMask(Vnew){
				this.isModalflag=Vnew;
			},
			countCurrency(Vnew){
				console.log(Vnew)
			},
			userCurrency(Vnew){
				console.log(Vnew)
			}
			
		},
		data(){
			return {
				isModalflag:false
				}
		},
		mounted(){
			
		},
		methods:{
			closeFlag(){
				
			},
			gotoCharge(){
				if(this.countCurrency<=this.userCurrency){
					this.$emit('buyChange',1)//确认订购
				}else{
					this.$emit('buyChange',2)//充值
					}
			},
			closeMask(){
				this.$emit('buyChange',false)
				this.isModalflag=false;
			}
		},
		}
</script>

<style scoped>
	.pop-mask{
		position:fixed;
		left:0px;
		background-color:rgba(0,0,0,.5);
		width:100%;
		height:100%;
		top:0px;
		z-index:10001;
	}
	.mask-content{
		width:100%;
		height:282px;
		padding:30px;
		box-sizing:border-box;
		background-color:#fff;
		position:absolute;
		left:0px;
		bottom:0px;
		border-radius:30px 30px 0px 0px; 
		text-align:center;
		/* height:calc(48px + env(safe-area-inset-bottom)); */
		padding-bottom: constant(safe-area-inset-bottom);
		/* 兼容 iOS < 11.2 */
		padding-bottom:env(safe-area-inset-bottom);
	}
	.mask-content>span{
		font-size: 22px;
		color: #333333;
		margin-bottom:42px;
		display:inline-block;
	}
	.mask-content>div{
		display:flex;
		    justify-content: space-between;
			margin-bottom:23px;
			font-size: 16px;
			color: #333333;
	}
	.mask-content>div.btn{
		background: #EC4C4C;
		border-radius: 100px;
		height:50px;
		color:#fff;
		text-align:center;
		line-height:50px;
		display:block;
		margin-top:37px;
		margin-bottom:0px;
		font-size: 18px;
	}
	
</style>



// WEBPACK FOOTER //
// src/view/components/buyBook.vue